const divModalDocCompany = {
  uploadSubmitError: 'Wait for all files to upload',
  uploadEmptyFileError: 'Minimum 1 file required'
};

export default divModalDocCompany;
